import FarloUiCrm from '../../vendors/farlo-ui-crm';

export function farloUiCrmSignup(_sel) {
    let farloUiSignupForm = null;

    if (typeof _sel.target !== 'undefined' && _sel.target !== null) {
        if (_sel.target.dataset.crmButtonFor !== '') {
            farloUiSignupForm = new FarloUiCrm(_sel.target.dataset.crmButtonFor);
        }
    } else if (farloUiSignupForm) {
        farloUiSignupForm.toggleForm();
    } else {
        farloUiSignupForm = new FarloUiCrm(_sel.id);
    }
}